import { useMemo } from 'react';
import {
	METERS_PER_DEGREE_LAT as metersPerDegreeLat,
	metersPerDegreeLng,
	resolveRoutePoints,
	computeRouteMetrics,
} from 'features/Responder/features/Tours/utils';

/**
 * Decode route polylines and precompute helper metrics for projecting points.
 * @param {any} routeData
 * @param {any} activeTripData
 * @returns {{ routePoints: Array<[number, number]>, routeMetrics: { cum: number[], total: number }, totalDurationSeconds: number|null, metersPerDegreeLat: number, metersPerDegreeLng: (lat: number) => number }}
 */
export function useRouteProjection(routeData, activeTripData) {
	const routePoints = useMemo(() => {
		return resolveRoutePoints(routeData, activeTripData);
	}, [routeData, activeTripData]);

	const totalDurationSeconds = useMemo(() => {
		if (typeof routeData?.totalDuration === 'number')
			return routeData.totalDuration;
		if (typeof routeData?.totalDuration === 'string') {
			const num = parseFloat(routeData.totalDuration.replace('s', ''));
			if (Number.isFinite(num)) return num;
		}
		if (Array.isArray(routeData?.legs)) {
			return routeData.legs.reduce((sum, leg) => {
				if (typeof leg.duration === 'number') return sum + leg.duration;
				if (typeof leg.duration === 'string') {
					const n = parseFloat(leg.duration.replace('s', ''));
					return sum + (Number.isFinite(n) ? n : 0);
				}
				return sum;
			}, 0);
		}
		return null;
	}, [routeData]);

	const routeMetrics = useMemo(
		() => computeRouteMetrics(routePoints),
		[routePoints]
	);

	return {
		routePoints,
		routeMetrics,
		totalDurationSeconds,
		metersPerDegreeLat,
		metersPerDegreeLng,
	};
}


